import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import withDeviceType from './with-device-type';
import withHocName from './with-hoc-name';

const mapStateToProps = (_, { isDesktop }) => ({
  isPostSettingsEnabled: isDesktop,
});

const withIsPostSettingsEnabled = flowRight(
  withDeviceType,
  connect(mapStateToProps),
  withHocName('WithIsPostSettingsExperimentEnabled'),
);

export default withIsPostSettingsEnabled;
